import { render, staticRenderFns } from "./user-not-found.html?vue&type=template&id=8841859c&"
import script from "./user-not-found.vue?vue&type=script&lang=js&"
export * from "./user-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports